const STAGE = {
  local: {
    url: 'http://localhost:8000',
  },
  homologation: {
    url: 'https://api.appcativa.h2k.com.br',
  },
  production: {
    url: 'https://api.appcativa.h2k.com.br',
  },
};

export const API_URL = `${STAGE.production.url}/api/v1`;

export const BROWSER_LANGUAGE = window.navigator.language;
